/**
 * CodeUnlockReducer
 *
 * Handles state for the code-redemption flow.
 *
 * Real API response from /packs/dc/redeem-code:
 * {
 *   data: [
 *     {
 *       id, idUnique, idPack,
 *       firstName, lastName,
 *       originalHeadshotUrl,
 *       packName, packImageUrl,
 *       created, updated, startDate, endDate
 *     }
 *   ]
 * }
 *
 * "Invalid code" is signalled by an empty data array or a non-zero errorCode.
 *
 * Export from src/reducers/index.js:
 *   export { default as codeUnlock } from './CodeUnlockReducer';
 */

const initialState = {
    loading:      false,
    error:        false,
    errorMessage: '',
    cards:        [],
    redeemed:     false,
};

export default (state = initialState, action) => {
    switch (action.type) {

        case 'REDEEM_CODE_START': {
            return { ...initialState, loading: true };
        }

        case 'REDEEM_CODE_FINISH': {
            const payload = action.payload;

            // Success path: errorCode "0" (mirrors every other API in the project)
            // AND the data array must be non-empty
            const apiSuccess  = !payload.errorCode || payload.errorCode === '0';
            const cards       = Array.isArray(payload.data) ? payload.data : [];
            const hasCards    = cards.length > 0;
            const success     = apiSuccess && hasCards;

            return {
                ...state,
                loading:      false,
                error:        !success,
                errorMessage: !success ? (payload.message || 'Invalid code') : '',
                cards:        success ? cards : [],
                redeemed:     success,
            };
        }

        case 'REDEEM_CODE_ERROR': {
            return {
                ...state,
                loading:      false,
                error:        true,
                errorMessage: action.payload.message || 'An error occurred',
                cards:        [],
                redeemed:     false,
            };
        }

        case 'REDEEM_CODE_RESET': {
            return { ...initialState };
        }

        default:
            return state;
    }
};
